import { type ReactNode } from "react";

import { IconSparkle } from "@btnet/blueprint-icons";
import { cn } from "@btnet/utilities-core";

import { BTLayoutContent } from "commonComponents/btWrappers/BTLayout/BTLayout";
import { BTModal } from "commonComponents/btWrappers/BTModal/BTModal";
import { BTModalLayout } from "commonComponents/btWrappers/BTModal/BTModalLayout";

import "./AutofillModalShell.less";

interface IAutofillModalShellProps {
    /** Additional className for the outer BTModal, for per-modal style hooks beyond the shared chrome. */
    className?: string;
    /** Shared prefix for the modal/layout testids, e.g. "autofillFromUrl" -> "autofillFromUrlModal". */
    testIdBase: string;
    modalTitle: string;
    layoutTitleText: string;
    visible: boolean;
    onCancel: () => void;
    footerContent?: ReactNode;
    width?: string;
    children: ReactNode;
}

export function AutofillModalShell(props: Readonly<IAutofillModalShellProps>) {
    return (
        <BTModal
            className={cn("AutofillModalShell", props.className)}
            data-testid={`${props.testIdBase}Modal`}
            title={props.modalTitle}
            visible={props.visible}
            beforeClose={props.onCancel}
            centered
            useModalLayout
            removeBodyPadding
            setPageTitle={false}
            width={props.width ?? "480px"}
        >
            <BTModalLayout
                title={
                    <span className="autofill-title">
                        <IconSparkle />
                        {props.layoutTitleText}
                    </span>
                }
                testId={`${props.testIdBase}ModalLayout`}
                modalConfig={{ beforeClose: props.onCancel, parentRoute: "" }}
                footerContent={props.footerContent}
            >
                <BTLayoutContent>{props.children}</BTLayoutContent>
            </BTModalLayout>
        </BTModal>
    );
}
